module.exports = __webpack_public_path__ + "img/sec2_03.5f16c24f.png";